

export interface INewItem {
    itemID: number;
    sellerID: number;
    categoryID: number;
    itemName: string;
    primaryImage: string;
    price: number;
    description: string;
    minOfferQty: number;
    bulkDiscountEnabled: boolean;
    bulkMinQty: number;
    bulkDiscount: number;
    infoLinkTitle: string;
    infoLinkUrl: string;
    infoLinkText: string;
    availableRegion: string;
    keywords:string;
    useStoreReturnPolicy:boolean;
    useItemReturnPolicy: boolean;
    itemReturnPolicy: string;
    useStoreShippingPolicy: boolean;
    useItemShippingPolicy: boolean;
    itemShippingPolicy: string;
}

export class ItemImage {
    itemImageID: number;
    itemID: number;
    fileName: string;
    sortOrder: number;

    constructor(itemImage: any) {
        this.itemImageID = itemImage.itemImageID;
        this.itemID = itemImage.itemID;
        this.fileName = itemImage.fileName;
        this.sortOrder = itemImage.sortOrder || 99;
    }
}

export class ItemImageFile  {
    file: File;
    sortOrder:number;

    constructor(file: File, sortOrder: number = 99) {
        this.file = file;
        this.sortOrder = sortOrder;
    }
}

export class ItemModel {
  itemId: number;
  sellerId: number;
  categoryId: number;
  itemName: string;
  primaryImage: string;
  price: number;
  description: string;
  listed: boolean;
  images: ItemImage[];
  views: number;
  featured: boolean;
  minOfferQty: number;
  bulkDiscountEnabled: boolean;
  bulkMinQty: number;
  bulkDiscount: number;
  infoLinkTitle: string;
  infoLinkUrl: string;
  infoLinkText: string;
  availableRegion: string;
  reviewState: string ; // "Pending", "Approved", "Rejected"
  reviewComment: string;
  keywords: string;
  useStoreReturnPolicy: boolean;
  useItemReturnPolicy: boolean;
  itemReturnPolicy: string;
  useStoreShippingPolicy: boolean;
  useItemShippingPolicy: boolean;
  itemShippingPolicy: string;

  constructor(item?: INewItem | any) {
    item = item || {};  // <-- default empty object to avoid undefined

    this.itemId = item.itemID ?? 0;
    this.sellerId = item.sellerID ?? 0;
    this.categoryId = item.categoryID ?? 0;
    this.itemName = item.itemName ?? "";
    this.primaryImage = item.primaryImage ?? "";
    this.price = item.price ?? 0;
    this.description = item.description ?? "";
    this.listed = item.listed ?? false;
    this.images = Array.isArray(item.images) ? item.images.map((img: any) => new ItemImage(img)) : [];
    this.views = item.views ?? 0;
    this.featured = item.featured ?? false;
    this.minOfferQty = item.minOfferQty ?? 0;
    this.bulkDiscountEnabled = item.bulkDiscountEnabled ?? false;
    this.bulkMinQty = item.bulkMinQty ?? -1;
    this.bulkDiscount = item.bulkDiscount ?? 1;
    this.infoLinkTitle = item.infoLinkTitle ?? "";
    this.infoLinkUrl = item.infoLinkUrl ?? "";
    this.infoLinkText = item.infoLinkText ?? "";
    this.availableRegion = item.availableRegion ?? "";
    this.reviewState = item.reviewState ?? "";
    this.reviewComment = item.reviewComment ?? "";

    this.keywords = item.keywords ?? "";
    this.useStoreReturnPolicy = item.useStoreReturnPolicy ?? true;
    this.useItemReturnPolicy = item.useItemReturnPolicy ?? false;
    this.itemReturnPolicy = item.itemReturnPolicy ?? "";
    this.useStoreShippingPolicy = item.useStoreShippingPolicy ?? true;
    this.useItemShippingPolicy = item.useItemShippingPolicy ?? false;
    this.itemShippingPolicy = item.itemShippingPolicy ?? "";
  }
}